import api from "../../../api/axios";

const SearchSites = async (searchstring) => {
  try {
    const { data } = await api.get("/api/servers/search/" + searchstring);

    return { success: true, data };
  } catch (error) {
    console.error("SearchSites response", error);
    return { success: false, loggedOut: error.response.status === 403 };
  }
};

export default { SearchSites };
